import { FormType } from '@cod-monorepo/interfaces';
import { StepConfig } from '../../../../shared/types/step-config.type';

export const ProductDamageInternationalStepConfig: StepConfig = {
    type: FormType.PRODUCT_DAMAGE_INTERNATIONAL
};
